import React from "react";
import { motion } from "framer-motion";

const imageUrls = [
  "https://media.istockphoto.com/id/1974848321/photo/environmental-goals-of-green-business-business-development-strategy-with-sustainable.webp?a=1&b=1&s=612x612&w=0&k=20&c=I_KppGIH73lZO607Wo3uhmZ0AkoGeC5w9S7eFGEO2qw=",
  "https://images.unsplash.com/photo-1598368195835-91e67f80c9d7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGRlc2lnbmVyfGVufDB8fDB8fHww",
  "https://images.unsplash.com/photo-1493612276216-ee3925520721?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8aW5ub3ZhdGlvbnxlbnwwfHwwfHx8MA%3D%3D",
  "https://images.unsplash.com/photo-1523875194681-bedd468c58bf?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8c3RyYXRlZ3l8ZW58MHx8MHx8fDA%3D",
  "https://images.pexels.com/photos/27695207/pexels-photo-27695207/free-photo-of-real-estate-finance-template-background.jpeg?auto=compress&cs=tinysrgb&w=600",
  "https://images.pexels.com/photos/26841237/pexels-photo-26841237/free-photo-of-euro-currency-banknote.jpeg?auto=compress&cs=tinysrgb&w=600"
];

const categories = [
  { name: "Impact", text: "Our projects go beyond bricks and mortar—we shape communities, enhance infrastructure, and drive economic growth. With every building we construct, we leave a lasting legacy of quality, functionality, and positive transformation." },
  { name: "Innovation", text: "Innovation is at the heart of everything we do. From adopting smart construction techniques to integrating sustainable materials, we continuously push the boundaries to deliver modern, efficient, and future-ready solutions that stand the test of time." },
  { name: "Strategy", text: "Our strategy is built on a foundation of precision, efficiency, and sustainability. By combining industry best practices with forward-thinking approaches, we ensure seamless project execution, cost-effective solutions, and structures that exceed expectations." },
  { name: "Growth", text: "We grow by embracing innovation, expanding our expertise, and delivering excellence. Through strategic investments and sustainable practices, we continue to build bigger, smarter, and more impactful projects." },
  { name: "Leadership", text: "Great leadership means setting the standard for excellence. Our experienced team drives innovation, fosters collaboration, and ensures every project reflects our commitment to quality and integrity." }
];

const Homebody2 = () => {
  return (
    <div className="bg-[#F7F8F9] text-gray-900 py-10">
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="max-w-7xl mx-auto text-center px-6 py-12"
      >
        <h2 className="text-4xl font-bold text-[#29313F] mb-4">Our Vision</h2>
        <p className="text-lg text-gray-600 mb-8">
          We envision a world where every structure tells a story of strength, innovation, and sustainability. By merging advanced technology with timeless craftsmanship, we create spaces that redefine excellence and inspire future generations.
        </p>
        <a href="/services">
          <button className="bg-[#29313F] text-white py-3 px-6 rounded-xl shadow-lg hover:bg-[#29313F] transition-all duration-300">
            Explore Our Vision
          </button>
        </a>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
        className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 px-6 py-12"
      >
        {categories.map((category, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: index * 0.3 }}
            className="bg-white rounded-lg shadow-xl overflow-hidden group transform transition-all hover:scale-105"
          >
            <img
              src={imageUrls[index]}
              alt={category.name}
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="text-2xl font-semibold text-[#29313F] mb-4">{category.name}</h3>
              <p className="text-gray-600 group-hover:text-[#29313F] transition-colors">
                {category.text}
              </p>
            </div>
          </motion.div>
        ))}
      </motion.section>
    </div>
  );
};

export default Homebody2;
